export default __webpack_public_path__ + "static/media/pause.0a252cb8.svg";